import { render } from "./HeaderView.vue?vue&type=template&id=e46e7b4a"
import script from "./HeaderView.vue?vue&type=script&lang=js"
export * from "./HeaderView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\chany\\Desktop\\my\\apache\\project\\youtube\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__